import React, { useState } from 'react';
import { Box, Grid } from "@mui/material";
import ButtonComponent from "./ButtonComponent";
import { COLORS } from "../config/theme";
import UploadFile from "./UploadFile";
import CustomTextarea from "./CustomTextarea";

const ExpedienteFinalizar = ({ handleFinish, setIsVisibleModal, reload, setReload}) => {
  const [observation, setObservation] = useState('');
  const [fileSelectedext, setFileSelected] = useState([]);

  const handleObservationChange = (event) => {
    setObservation(event.target.value);
  };

  const handleSubmit = () => {
    handleFinish({files: fileSelectedext, observation: observation});
    setIsVisibleModal(false);
    setReload(!reload)
  };

  const handleCompleteSelection = async() => {
    console.log("Archivo seleccionado", fileSelectedext);
  }

  const closeForm = () => {
    console.log("Close"); 
    return setIsVisibleModal(false);
}

  return (
    <>
        <Grid item xs={12}>
            <UploadFile
                setFileSelected={setFileSelected}
                fileSelectedext={fileSelectedext}
                onCompleteFileSelection={handleCompleteSelection}
            />
        </Grid>
        <Grid item xs={12} style={{marginTop: 20}}>
            <CustomTextarea
                rows={3}
                value={observation}
                onChange={handleObservationChange}
                label="Observación"
              />            
        </Grid>
        <Grid item xs={12}>
            <Box display="flex" justifyContent="space-between">
            <ButtonComponent
                name="Guardar"
                toAction={handleSubmit}
            />
            <div style={{ width: "5px" }}></div>
            <ButtonComponent
                name="Cancelar"
                toAction={closeForm}
                color={COLORS.DANGER}
            />
            </Box>
        </Grid>  
    </>
  );
};

export default ExpedienteFinalizar;
